<template>
  <div>
    <p class="text-c f-s-8">活动规则</p>
    <van-image
    class="m-t-05"
      :src="imgUrl"
    />
  </div>
</template>

<script>
export default {
  props:{},
  data(){
    return {
      imgUrl:require('@/assets/imgs/process.png')
    }
  }
}
</script>

<style lang="less" scoped>
.ruleDetials {
  font-size: 0.6rem;
  color: #73787F;
}
</style>